import React from "react";
import { useState, useEffect } from "react";
import { LuCalendarCheck } from "react-icons/lu";
import ReactTooltip from "react-tooltip";
import { Alert, Button, Col, Row, UncontrolledAlert, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from "../../../../axios";
import {
  LayoutHeadingShadow,
  LayoutHeadingShadowLeft,
  LayoutRowShadow,
} from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import { toastContainer } from "../../../../utils/toast";
import * as url from "../../../../utils/url";
import DaniContainer from "../../../dani/DaniContainer";
import DaniHeader from "../../../dani/DaniHeader";
import { LayoutData } from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actionCreators from "../../../../modules/actions";
import parse from "react-html-parser"
import { isMobile } from '../../../../utils/deviceInfo'

import {
  BiCheckbox,
  BiCheckboxChecked,
  BiLinkExternal,
  BiX,
} from "react-icons/bi";
import { BsDash } from "react-icons/bs";
import TrivvyCreateSteps from "./LoaderBoxSteps";
import ViewSummaryCommon from "../../../../components/Trivvy/ViewSummarycomon";
import { getTriviaFileName } from "../../data";
import "./loaderbox-bwai.css";

function CreateLibraryLoaderBox({
  loaderApiData,
  user,
  setCreateLibraryLoader,
  createLibraryLoader,
  ...props
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [summaryText, setSummaryText] = useState("");
  const [summaryGenerated, setsummaryGenerated] = useState(false)
  const [generatedLibrary, setGeneratedLibrary] = useState(null)
  const [customModalText, setCustomModalText] = useState(null);

  const [loadingSteps, setLoadingSteps] = useState([
    {
      stepNumber: 1,
      stepText: "Uploading data",
    },
    {
      stepNumber: 2,
      stepText: "",
    },
    {
      stepNumber: 3,
      stepText: "",
    },
  ]);


  const renderUploadingHtml = (content, contentType) => {

    if (content) {
      if (contentType == "LINK") {
        return parse(`<div>Uploading <a href="${content}" style={{wordBreak:"break-all"}} target="_blank">${content.length > 50 ? `${content.slice(0, 50)}...` : content}</a></div>`)
      } else if (contentType == "TEXT") {
        return parse(`<div>Uploading "<span style={{wordBreak:"break-all"}}>${content.length > 50 ? `${content.slice(0, 50)}...` : content}</span>"</div>`)
      }
    }

  }

  const renderContentHtmlGeneratingSummary = (content, contentType) => {
    if (content) {
      if (contentType == "TEXT") {
        return parse(`<div>Generating summary on "<span style={{wordBreak:"break-all"}}>${content.length > 50 ? `${content.slice(0, 50)}...` : content
          }</span>"</div>`);
      } else {
        return parse(`<div>Generating summary on <a href="${content}" style={{wordBreak:"break-all"}} target="_blank">${content.length > 50 ? `${content.slice(0, 50)}...` : content
          }</a></div>`);
      }
    } else {
      return "Uploading data...";
    }
  };
  const renderContentHtmlViewSummary = (summaryText) => {
    return (
      <div>
        Summary generated succesfully.{" "}
        <ViewSummaryCommon
          summaryText={summaryText}
          btnUi={<b style={{ textDecoration: "underline", cursor: "pointer" }}>View Summary</b>}
        />{" "}
      </div>
    );
  };

  const changeStepText = (index, newText) => {
   
    const stepsArr = [...loadingSteps];

    stepsArr[index].stepText = newText;

    setLoadingSteps(stepsArr);
  };

  const addStep = (stepObj) => {
    const stepsArr = [...loadingSteps];

    stepsArr.push(stepObj)

    setLoadingSteps(stepsArr);
  };



  const onViewClick = async (e, id, model, { inline = true } = {}) => {
    e.preventDefault();
  
    try {
        const { data } = await axios.get(url.getSignedUrl, {
          params: { id, model, inline: inline ? 1 : 0 },
        });

        const signedUrl = data.url;
        if (!signedUrl) throw new Error('No signed URL returned');

        window.open(signedUrl, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error('Failed to get signed URL', err);
    }
  };

  useEffect(() => {
    if (loaderApiData) {


      const newPayload = {
        ...loaderApiData.payload,
      };


     

      setCurrentStep(1);


      changeStepText(
        0,
        renderUploadingHtml(
          loaderApiData.content,
          loaderApiData.contentType
        )
      );

      setGeneratedLibrary(newPayload)

      axios
        .post(url.createTriviaLbraryDoc, loaderApiData.triviaForm)
        .then((res) => {
          const d = res.data.data;
          setGeneratedLibrary(d)
          

          if (newPayload.isGenerateSummary) {
       
            const summaryContent = d.librarySourceType === 0 ? d.webUrl : d.librarySourceType === 1 ? d.s3Url : d.librarySourceType === 2 ? d.text : ""
            const summaryContentType = d.librarySourceType === 0 ? "LINK" : d.librarySourceType === 1 ? "LINK" : d.librarySourceType === 2 ? "TEXT" : ""
            changeStepText(
              0,
              "Uploaded succesfully"
            );
            changeStepText(
              1,
              renderContentHtmlGeneratingSummary(summaryContent, summaryContentType)
            );
            setCurrentStep(2)

            axios
              .get(url.generateAndStoreSummaryForLibrarySource(d._id))
              .then(({ data }) => {
                setsummaryGenerated(true)
                setCurrentStep(4);
             
                changeStepText(
                  2,
                  renderContentHtmlViewSummary(data.data.summaryText)
                );
                if (loaderApiData.cb) {
                  loaderApiData.cb(data.data)
                }
              })
              .catch((err) => {
                console.log(err);
                setCreateLibraryLoader({
                  minimize: true,
                  display: false,
                  loaderApiData: null,
                });
              });

          } else {
            setCurrentStep(2)    
            setLoadingSteps([
              {
                stepNumber: 1,
                stepText: "Uploaded successfully",
              }])
            if (loaderApiData.cb) {
              loaderApiData.cb(d)
            }

          }
        })
        .catch((err) => {
          console.log(err);
                setCreateLibraryLoader({
                  minimize: true,
                  display: false,
                  loaderApiData: null,
                });
        });




    }
  }, []);

  return (
    <div
      className={
        summaryGenerated
          ? "bwai-loader-box bwai-loader-box--library summaryGenerated"
          : "bwai-loader-box bwai-loader-box--library"
      }
    >
      {customModalText && (
        <Modal isOpen={true} className={isMobile ? 'm-0' : ''}>
          <ModalHeader
            toggle={() => {
              setCustomModalText(null)
            }}
          >
            <div>
              <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                Text Content
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="p-3">
            <div style={{ fontSize: '14px', color: '#374151', whiteSpace: 'pre-wrap' }}>
              {customModalText}
            </div>
          </ModalBody>
          <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
            <Button
              onClick={() => setCustomModalText(null)}
              style={{
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 20px',
                borderRadius: '6px',
                backgroundColor: '#f3f4f6',
                border: 'none',
                color: '#374151',
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
      <DaniContainer
        height={isMobile ? 350 : 480}
        width={isMobile ? 310 : 450}
        minWidth={isMobile ? 310 : 450}
        opened={true}
        minimized={createLibraryLoader.minimize}
      >
        <DaniHeader
          summaryGenerated={summaryGenerated}
          style={{
            backgroundColor: summaryGenerated ? "#d4edda" : "",
          }}
        >
          <div
            className="text-center font-weight-bold"
            style={{ color: "black", width: "80%", fontSize: "1.1em" }}
          >
            {summaryGenerated ? (
              <span style={{ color: "#073d13 !important" }}>
                Completed <BiCheckboxChecked />{" "}
              </span>
            ) : (
              "Uploading"
            )}
          </div>
          <div
            className="cursor-pointer ml-2"
            style={{ color: "black" }}
            onClick={() => {
              setCreateLibraryLoader({
                ...createLibraryLoader,
                minimize: !createLibraryLoader.minimize,
              });
            }}
          >
            {createLibraryLoader.minimize ? <BiLinkExternal /> : <BsDash />}
          </div>
          <div
            className="cursor-pointer ml-2"
            style={{ color: "black" }}
            onClick={() => {
              setCreateLibraryLoader({
                display: false,
                loaderApiData: null,
                minimize: false,
              });
            }}
          >
            <BiX />
          </div>
        </DaniHeader>

        {!createLibraryLoader.minimize ? (
          <div>
            <div>
              <TrivvyCreateSteps
                currentStep={currentStep}
                steps={loadingSteps}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {/* Gated like bug852's loader: the panel is now height:auto, so a
            minimised bar no longer clips this block to 40px. */}
        {!createLibraryLoader.minimize && (
        <div className="m-0 px-4">

          {
            generatedLibrary &&   <LayoutRowShadow>
            <LayoutData colWidth={8} colWidthMobile={8} className="cursor-pointer">

              <span
                style={{ display: "block" }}
                className="survey-item-title d-block"
              >
                
                {getTriviaFileName({
                  uploadUrl: generatedLibrary.s3Url,
                  uploadFileName: generatedLibrary.s3Key,
                  clip: true,
                  librarySourceType: generatedLibrary.librarySourceType,
                  libName: generatedLibrary.name,
                  webUrl:generatedLibrary.webUrl
                })}
              </span>

            </LayoutData>



            <LayoutData className="text-center" colWidth={2} colWidthMobile={4}>
              {generatedLibrary && generatedLibrary._id ? (


                <Button
                  onClick={(e) => {
                    if (generatedLibrary.librarySourceType == 0 && generatedLibrary.webUrl) {
                      window.open(generatedLibrary.webUrl, '_blank')
                    } else if (generatedLibrary.librarySourceType == 2 && generatedLibrary.text) {
                      // Text view not supported in loader box yet
                      setCustomModalText(generatedLibrary.text)
                    } else {
                      onViewClick(e, generatedLibrary._id, 'TriviaResource')
                    }
                  }}
                  size="sm"
                  className="trivia-action-button-main"
                >
                  {" "}
                  View{" "}
                </Button>
              ) : (
                <span className="trivvy-loader mx-auto" />
              )}
            </LayoutData>
          </LayoutRowShadow>
          }




        </div>
        )}
      </DaniContainer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    createLibraryLoader: state.trivia.createLibraryLoader || {
      display: false,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCreateLibraryLoader: (data) =>
      dispatch(actionCreators.setCreateLibraryLoader(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateLibraryLoaderBox, axios));
